/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IRevisionHistoryConnectMessage extends IMessage {
	documentId: string;
}

export default class RevisionHistoryConnectMessage extends Message {
	public static readonly TYPE: string = '121';

	public static readonly READABLE_TYPE_NAME: string = 'connectToRevisionHistory';

	public static readonly DESCRIPTOR_NAME: string = 'RevisionHistoryConnectMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			documentId: {
				type: 'string',
				id: 1
			}
		}
	};

	public constructor( public readonly documentId: string ) {
		super();
	}

	public toJSON(): IRevisionHistoryConnectMessage {
		return {
			documentId: this.documentId
		};
	}

	public static fromJSON( object: IRevisionHistoryConnectMessage ): RevisionHistoryConnectMessage {
		return new RevisionHistoryConnectMessage( object.documentId );
	}
}
